// Wspólny „humanizer" błędów API (2026-07-23, audyt UX Tier 1).
//
// ZASADA: użytkownikowi NIGDY nie pokazujemy surowego `err.message` axiosa
// ("Network Error", "timeout of 600000ms exceeded", "Request failed with status
// code 500") ani `JSON.stringify(detail)`. Techniczny szczegół idzie do konsoli,
// a adwokat dostaje zrozumiały, profesjonalny komunikat po polsku.
//
// Użycie:
//   import { humanizeApiError } from "../lib/errors";
//   catch (err) { setError(humanizeApiError(err, "wygenerować pismo")); }
//
// `action` = czasownik w bezokoliczniku do fallbacku ("wygenerować pismo",
// "przygotować poradę", "wysłać wiadomość"). Wchodzi tylko do ogólnego zdania
// "Nie udało się {action}. Spróbuj ponownie." — reszta gałęzi jest samodzielna.

export function humanizeApiError(err, action = "wykonać operację") {
  // Diagnostyka do konsoli — nie do UI.
  try {
    // eslint-disable-next-line no-console
    console.error("[API]", action, err?.response?.status, err);
  } catch (_) {
    /* noop */
  }

  const res = err?.response;
  const detail = res?.data?.detail;

  // 422 — walidacja Pydantic; detail to tablica z ANGIELSKIMi komunikatami
  // ("field required", "value is not a valid email address"). Nie pokazujemy ich.
  if (res?.status === 422) {
    return "Sprawdź poprawność wprowadzonych danych i spróbuj ponownie.";
  }

  // Backend podał czytelny komunikat (string) — jest projektowany po polsku i dla
  // użytkownika, więc pokazujemy go wprost.
  if (typeof detail === "string" && detail.trim()) {
    return detail.trim();
  }

  // Brak odpowiedzi = problem sieci/serwera po naszej stronie, nie wina usera.
  if (!res) {
    if (/timeout|exceeded/i.test(err?.message || "")) {
      return "Operacja trwała zbyt długo i została przerwana. Spróbuj ponownie.";
    }
    return "Brak połączenia z serwerem. Sprawdź sieć i spróbuj ponownie.";
  }

  // Serwer odpowiedział błędem 5xx bez czytelnego detalu.
  if (res.status >= 500) {
    return "Chwilowy problem po naszej stronie. Spróbuj ponownie za moment.";
  }

  // Fallback ogólny — po polsku, z akcją, bez surowego err.message.
  return `Nie udało się ${action}. Spróbuj ponownie.`;
}
